<template>
    <div class="wrap">
        <div class="jiaxiang" v-show="!SHOW_SEL">
            <h1>您的“1+X”个性化定制套餐如下：</h1>
            <div class="tables first">
                <h3>基础项目“1”（必选）</h3>
                <table>
                    <thead>
                        <tr>
                            <td>序号</td>
                            <td>项目</td>
                            <td>临床意义</td>
                            <td>价格</td>
                            <td>选择</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(li,index) in BASE_ITEMS" :key="index" v-tip.click="getTipBase(li,index)"  :class="{rowactive:selIndex0==index}">
                            <td>{{index+1}}</td>
                            <td style="max-width:8em;">{{li.itemName}}</td>
                            <td style="min-width:10em;max-width:10em;">{{li.itemMeaning}}</td>
                            <td>{{li.itemPrice}}</td>
                            <td>√</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="tables">
                <h3>加项“X”（建议必选项）</h3>
                <table>
                    <thead>
                        <tr>
                            <td>序号</td>
                            <td>项目</td>
                            <td>临床意义</td>
                            <td>价格</td>
                            <td>选择</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(li,index) in ADJUST_ITEMS" :key="index" v-tip.click="getTipADJUST(li,index)"  :class="{rowactive:selIndex1==index}">
                            <td>{{index+1}}</td>
                            <td style="max-width:8em;">{{li.itemName}}</td>
                            <td style="min-width:10em;max-width:10em;">{{li.itemMeaning}}</td>
                            <td>{{li.itemPrice}}</td>
                            <td>
                                <!-- <input type="checkbox" :value="li.itemId" v-model="CHECKED_ITEMS"> -->
                                <van-checkbox v-model="li.checked" @click.native.stop="calPRICE"></van-checkbox>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="tables">
                <h3>加项“X”（可选项）</h3>
                <table>
                    <thead>
                        <tr>
                            <td>序号</td>
                            <td>项目</td>
                            <td>临床意义</td>
                            <td>价格</td>
                            <td>选择</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(li,index) in OTHER_ITEMS" :key="index" v-tip.click="getTipOTHER(li,index)"  :class="{rowactive:selIndex2==index}">
                            <td>{{index+1}}</td>
                            <td style="max-width:8em;">{{li.itemName}}</td>
                            <td style="min-width:10em;max-width:10em;">{{li.itemMeaning}}</td>
                            <td>{{li.itemPrice}}</td>
                            <td>
                                <!-- <input type="checkbox" :value="li.itemId" v-model="CHECKED_ITEMS"> -->
                                <van-checkbox v-model="li.checked" @click.native.stop="calPRICE"></van-checkbox>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="tcinfo">
                <h3>提示：</h3>
                <ul>
                    <li>1.为保证您的健康，建议勾选必选项，若取消“加项X”中的建议必选项，需要在体检时签署拒检同意书，谢谢。</li>
                    <li>2.及早发现潜在的危害健康危险因素。</li>
                    <li>3.提供准确的早期预警，让您更好的了解目前身体状况，</li>
                </ul>
            </div>
            <div class="buy">
                <!-- <div class="icons">
                                                                            <i class="iconfont icon-star-copy"></i>
                                                                        </div>
                                                                        <div class="line"></div> -->
                <div class="icons">
                    <!-- <i class="iconfont icon-gouwuche" @click="goShopCart"></i> -->
                    <i :class="[SHOPCART?'iconfont icon-03f':'iconfont icon-gouwuche']" @click="goShopCart"></i>
                </div>
                <div class="line"></div>
                <div class="price">
                    <span>总价：¥{{PRICE}}</span>
                </div>
                <button class="btnbuy" @click="submit">立即购买</button>
            </div>
        </div>
        <div class="personsel" v-show="SHOW_SEL">
            <personSel @INDIVIDUAL="selPerson" :action-type="ACTION"></personSel>
        </div>
    </div>
</template>

<script>
    import api from '@/fetch/api';
    import sapi from '@/fetch/surveyApi';
    import personSel from '@/pages/personSel'
    import itemTip from '@/components/itemInfo'
    import {
        mapGetters
    } from 'vuex';
    import {
        Dialog,
        Toast
    } from 'vant';
    export default {
        data() {
            return {
                BASE_ITEMS: [],
                ADJUST_ITEMS: [],
                OTHER_ITEMS: [],
                PRICE: 0,
                CHECKED_ITEMS: [],
                customerID: '',
                SHOW_SEL: false,
                ACTION: 0, //1:购物车，5：待付款
                SHOPCART: false,
                selIndex0: -1,
                selIndex1: -1,
                selIndex2: -1,
            }
        },
        components: {
            personSel,
            itemTip
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getCustomerID(vm)
            })
        },
        watch: {
            CHECKED_ITEMS(vals) {
                console.log(vals);
                let price = 0;
                this.BASE_ITEMS.forEach(el => {
                    price += parseFloat(el.itemPrice);
                });
                this.ADJUST_ITEMS.forEach(el => {
                    if (vals.findIndex(x => x == el.itemId) > -1)
                        price += parseFloat(el.itemPrice);
                });
                this.OTHER_ITEMS.forEach(el => {
                    if (vals.findIndex(x => x == el.itemId) > -1)
                        price += parseFloat(el.itemPrice);
                });
                this.PRICE = price;
            }
        },
        methods: {
            getCustomerID(el) {
                this.customerID = el.$route.params.customerID;
                console.log(this.customerID);
                console.log(this.userInfo.CUSTOMER_ID);
                sapi.getItems(this.customerID).then(re => {
                    let data = re.data;
                    console.log(data);
                    let price = 0;
                    data.forEach(el => {
                        let item = {
                            itemId: el.itemId,
                            itemName: el.itemName,
                            itemMeaning: el.itemMeaning,
                            itemPrice: el.itemPrice,
                            checked: false,
                        };
                        if (el.itemType == '必选项') {
                            item.checked = true;
                            this.BASE_ITEMS.push(item);
                            price += parseFloat(el.itemPrice);
                        } else if (el.itemType == '建议必选项') {
                            this.ADJUST_ITEMS.push(item);
                        } else if (el.itemType == '建议可选项') {
                            this.OTHER_ITEMS.push(item);
                        }
                    });
                    this.PRICE = price;
                });
            },
            goShopCart() {
                // this.ACTION = 1;
                // this.SHOW_SEL = true;
                if (this.customerID != '') {
                    let basicItemIds = [];
                    let addItemIDs = [];
                    // this.CHECKED_ITEMS.forEach(v => addItemIDs.push(v));
                    this.BASE_ITEMS.forEach(v => basicItemIds.push(v.itemId));
                    this.ADJUST_ITEMS.filter(v => v.checked == true).forEach(v => addItemIDs.push(v.itemId));
                    this.OTHER_ITEMS.filter(v => v.checked == true).forEach(v => addItemIDs.push(v.itemId));
                    let params = {
                        COMBO_ID: '',
                        basicItemId:basicItemIds,
                        addItemId: addItemIDs,
                        STATUS: 1,
                        PRICE: this.PRICE,
                        TYPE: 1
                    };
                   
                    //加入购物车
                    api.weixinOrder(this.customerID, this.userInfo.CUSTOMER_ID, params)
                        .then(res => {
                            console.log(res);
                            if (res.result == true) {
                                Toast.success('添加购物车成功');
                                this.SHOPCART = true;
                            }
                        });
                }
            },
            submit() {
                // this.ACTION = 5;
                // this.SHOW_SEL = true;
                if (this.customerID != '') {
                    // let addItemIDs = [];
                    // this.ADJUST_ITEMS.filter(v => v.checked == true).forEach(v => addItemIDs.push(v.itemId));
                    // this.OTHER_ITEMS.filter(v => v.checked == true).forEach(v => addItemIDs.push(v.itemId));
                    // let params = {
                    //     COMBO_ID: '',
                    //     addItemId: addItemIDs,
                    //     STATUS: 5,
                    //     PRICE: this.PRICE,
                    //     TYPE: 1
                    // };
                    // //立即购买
                    // api.weixinOrder(this.customerID, this.userInfo.CUSTOMER_ID, params)
                    //     .then(res => {
                    //         return res.data;
                    //     })
                    //     .then(v => {
                    //         api.getCustomerInfo(this.customerID).then(re => {
                    //             let data = re.data;
                    //             let selItem = {
                    //                 PHONE_NUM: data.PHONE_NUM,
                    //                 PRICE: this.PRICE,
                    //                 RECORD_ID: v,
                    //                 TYPE: '“1+x”套餐',
                    //                 NAME: data.NAME
                    //             };
                    //             console.log(selItem);
                    //             sessionStorage.setItem('records', JSON.stringify(selItem));
                    //             this.$router.push('/user/confimOrder/' + v);
                    //         })
                    //     });
                    api.getCustomerInfo(this.customerID,this.userInfo.CUSTOMER_ID,this.userInfo.TOKEN).then(re => {
                        let data = re.data;
                        let selItem = {
                            PHONE_NUM: data.PHONE_NUM,
                            PRICE: this.PRICE,
                            RECORD_ID: '',
                            TYPE: '“1+x”套餐',
                            NAME: data.NAME,
                            customerID: this.customerID,
                            basicItems: [],
                            addItems: [],
                            COMBO_ID: '',
                            COMBO_TYPE: 1
                        };
                        this.BASE_ITEMS.forEach(v => selItem.basicItems.push({
                            CHECKITEM_ID: v.itemId,
                            CHECKITEM_NAME: v.itemName,
                            ITEM_COST: v.itemPrice
                        }));
                        this.ADJUST_ITEMS.filter(v => v.checked == true).forEach(v => selItem.addItems.push({
                            CHECKITEM_ID: v.itemId,
                            CHECKITEM_NAME: v.itemName,
                            ITEM_COST: v.itemPrice
                        }));
                        this.OTHER_ITEMS.filter(v => v.checked == true).forEach(v => selItem.addItems.push({
                            CHECKITEM_ID: v.itemId,
                            CHECKITEM_NAME: v.itemName,
                            ITEM_COST: v.itemPrice
                        }));
                        console.log(selItem);
                        window.scroll(0, 0);
                        sessionStorage.setItem('records', JSON.stringify(selItem));
                        this.$router.push('/user/confimOrder/gxhtc');
                    });
                }
            },
            selPerson(val) {
                console.log(val);
                this.SHOW_SEL = false;
                if (val != '' && val.INDIVIDUAL_ID != '' && val.INDIVIDUAL_ID != undefined) {
                    this.customerID = val.INDIVIDUAL_ID;
                    let addItemIDs = [];
                    // this.CHECKED_ITEMS.forEach(v => addItemIDs.push(v));
                    this.ADJUST_ITEMS.filter(v => v.checked == true).forEach(v => addItemIDs.push(v.itemId));
                    this.OTHER_ITEMS.filter(v => v.checked == true).forEach(v => addItemIDs.push(v.itemId));
                    let params = {
                        COMBO_ID: '',
                        addItemId: addItemIDs,
                        STATUS: val.ACTIONTYPE,
                        PRICE: this.PRICE,
                        TYPE: 1
                    };
                    if (val.ACTIONTYPE == 1) {
                        //加入购物车
                        api.weixinOrder(this.customerID, this.userInfo.CUSTOMER_ID, params)
                            .then(res => {
                                console.log(res);
                                if (res.result == true) {
                                    Toast.success('添加购物车成功');
                                }
                            });
                    } else if (val.ACTIONTYPE == 5) {
                        //立即购买
                        api.weixinOrder(this.customerID, this.userInfo.CUSTOMER_ID, params)
                            .then(res => {
                                return res.data;
                            })
                            .then(v => {
                                api.getCustomerInfo(this.customerID,this.userInfo.CUSTOMER_ID,this.userInfo.TOKEN).then(re => {
                                    let data = re.data;
                                    let selItem = {
                                        PHONE_NUM: data.PHONE_NUM,
                                        PRICE: this.PRICE,
                                        RECORD_ID: v,
                                        TYPE: '“1+x”套餐',
                                        NAME: data.NAME
                                    };
                                    console.log(selItem);
                                    sessionStorage.setItem('records', JSON.stringify(selItem));
                                    this.$router.push('/user/confimOrder/' + v);
                                })
                            });
                    }
                }
            },
            calPRICE() {
                let price = 0;
                this.BASE_ITEMS.forEach(el => {
                    price += parseFloat(el.itemPrice);
                });
                this.ADJUST_ITEMS.filter(el => el.checked == true).forEach(el => {
                    price += parseFloat(el.itemPrice);
                });
                this.OTHER_ITEMS.filter(el => el.checked == true).forEach(el => {
                    price += parseFloat(el.itemPrice);
                });
                this.PRICE = price;
            },
            getTipBase(obj,index0) {
                var that = this;
                return {
                    width: '80%',
                    transition: true,
                    container: document.getElementById('app'),
                    customProps: {
                        ITEM_NAME: obj.itemName,
                        PRICE: obj.itemPrice,
                        MEANING: obj.itemMeaning,
                        ENABLED: false,
                        STATUS: false,
                        SEL_INDEX: index0,
                    },
                    customListeners: {
                        close() {
                            that.$tip().hiddenTip();
                        },
                        sel(val) {
                            that.selIndex0 = val;
                            that.selIndex1 = -1;
                            that.selIndex2 = -1;
                        }},
                    customComponent: itemTip
                }
            },
            getTipADJUST(obj,index1) {
                var that = this;
                return {
                    width: '80%',
                    transition: true,
                    container: document.getElementById('app'),
                    customProps: {
                        ITEM_NAME: obj.itemName,
                        PRICE: obj.itemPrice,
                        MEANING: obj.itemMeaning,
                        ENABLED: false,
                        STATUS: (that.ADJUST_ITEMS.findIndex(p => p.checked == true && p.itemId == obj.itemId) > -1),
                         SEL_INDEX: index1,
                    },
                    customListeners: {
                        operate(status) {
                            let item = that.ADJUST_ITEMS.find(p => p.itemId == obj.itemId);
                            if (status) {
                                //选择
                                if (item.checked == false) {
                                    item.checked = true;
                                    Toast.success('添加成功！');
                                }
                            } else {
                                //删除
                                if (item.checked == true) {
                                    item.checked = false;
                                    Toast.success('取消成功！');
                                }
                            }
                            that.$tip().hiddenTip();
                        },
                        close() {
                            that.$tip().hiddenTip();
                        },
                        sel(val) {
                            that.selIndex0 = -1;
                            that.selIndex1= val;
                            that.selIndex2 = -1;
                        }
                    },
                    customComponent: itemTip
                }
            },
            getTipOTHER(obj,index2) {
                var that = this;
                return {
                    width: '80%',
                    transition: true,
                    container: document.getElementById('app'),
                    customProps: {
                        ITEM_NAME: obj.itemName,
                        PRICE: obj.itemPrice,
                        MEANING: obj.itemMeaning,
                        ENABLED: false,
                        STATUS: (that.OTHER_ITEMS.findIndex(p => p.checked == true && p.itemId == obj.itemId) > -1),
                        SEL_INDEX: index2,
                    },
                    customListeners: {
                        operate(status) {
                            let item = that.OTHER_ITEMS.find(p => p.itemId == obj.itemId);
                            if (status) {
                                //选择
                                if (item.checked == false) {
                                    item.checked = true;
                                    Toast.success('添加成功！');
                                }
                            } else {
                                //删除
                                if (item.checked == true) {
                                    item.checked = false;
                                    Toast.success('取消成功！');
                                }
                            }
                            that.$tip().hiddenTip();
                        },
                        close() {
                            that.$tip().hiddenTip();
                        },
                         sel(val) {
                            that.selIndex0 = -1;
                            that.selIndex1 = -1;
                            that.selIndex2= val;
                        }
                    },
                    customComponent: itemTip
                }
            }
        }
    }
</script>

<style scoped lang='less'>
    .wrap {
        margin-bottom: 4rem;
        h1 {
            font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
            font-weight: 700;
            font-style: normal;
            font-size: 1rem;
            color: #43852E;
            text-align: center;
            padding: 0.5em 0;
        }
        table {
            font-size: 0.7rem;
        }
        .buy {
            // font-size: 0.6rem;
            font-size: 1rem;
        }
        .buy {
            font-family: "Microsoft YaHei" !important; // padding-left: 1em;
            .btnbuy {
                padding: 0 1.5em;
            }
            .price {
                span {
                    display: inline;
                    font-size: 1rem !important;
                    margin-left: 1em;
                }
            }
            button {
                right: 0;
            }
        }
        div.tables {
            border: 1px solid #8f6326;
            h3 {
                color: #8f6326;
            }

              .rowactive {
                background: #FF7C3E;
                td {
                    color: #fff !important;
                }
            }
        }
        .first {
            border: 1px solid #99C51D !important;
            h3 {
                color: #99C51D!important;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/GXHTC.vue